import React, { useEffect, useState } from 'react';
import { useLocation, } from 'react-router-dom';

import dayjs from 'dayjs';

import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { Badge } from '@mui/material'
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';

import PostIconStatus from './PostIconStatus';
import { iconColors } from '../helpers/scripts'

import cl from '../static/style.module.css'

const OrdersList = ({ orders, updateStatData, navigateToOrder, urlPage, updateUrlPage }) => {


    const location = useLocation();

    const [orderList, setOrderList] = useState([])

    const apiRef = useGridApiRef();

    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: urlPage,
    });

   

    const StyledBadge = styled(Badge)(({ theme }) => ({
        '& .MuiBadge-badge': {
            right: -3,
            top: 13,
            border: `2px solid ${theme.palette.background.paper}`,
            padding: '0 4px',
        },
    }));



    const creatPostIconStatus = (order) => {
        // gray: 0 ; yellow: 1; green: 2
        let statusCode = 0;

        const emailConfigOrder = order['source']['emailConfigOrder'];

        if (emailConfigOrder) {
            statusCode = 1
            const notifications = order['notifications'];

            if (emailConfigOrder && notifications.length > 0) {

                for (const notification of notifications) {
                    if (notification.type === 'order') {
                        statusCode = 2;
                        break;
                    }
                }
            }
        }
        return statusCode
    }

    const shipmentIconStatus = (statusCode) => {

        const [status, numbers] = statusCode

        let icon

        if (numbers || (status && numbers)) {
            icon = <StyledBadge badgeContent={numbers} color="primary"><MarkunreadMailboxIcon sx={{ color: '#1976d2' }} /></StyledBadge>

        // } else if (status === 1) {
        //     icon = <MarkunreadMailboxIcon sx={{ color: iconColors.yellow }} />
        } else {
            icon = <MarkunreadMailboxIcon sx={{ color: iconColors.gray }} />
        }

        return icon
    }

    const creatShipmentIconStatus = (order) => {
        // gray: 0 ; yellow: 1; green: 2
        let statusCode = [0, 0];

        statusCode[1] = order['shipments'].length


        if (order['source']['automaticShipment']) {
            statusCode[0] = 1
        }
        return statusCode
    }

    const creadOrederList = (orders) => {

        const lst = []
        const nb = orders.length
        let numberOfOrders = 0
        let totalQuantities = 0

        for (let i = 0; i < nb; i++) {
            numberOfOrders++
            totalQuantities = totalQuantities + orders[i]['totalQuantity']
            lst.push({
                id: orders[i]['id'],
                icon_post: creatPostIconStatus(orders[i]),
                icon_shipment: creatShipmentIconStatus(orders[i]),
                date: dayjs(orders[i]['date']).format('DD/MM/YYYY HH:mm:ss'),
                orderID: orders[i]['orderID'],
                source_name: orders[i]['source']['name'],
                address_country: orders[i]['address']['country'],
                address_city: orders[i]['address']['city'],
                totalQuantity: orders[i]['totalQuantity'],
                totalOrderPrice: parseFloat(orders[i]['totalOrderPrice']).toFixed(2),
                user: [orders[i]['user']['firstName'], orders[i]['user']['lastName']].join(' '),
                email: orders[i]['user']['email'],
                isCancel: orders[i]['isCancel']

            })
        }
        updateStatData({ 'numberOfOrders': numberOfOrders, 'totalQuantities': totalQuantities })
        setOrderList([...lst])

    }

    const columns = [
        {
            field: 'icon_post',
            headerName: '',
            width: 1,
            // renderCell: (e) => { return (<> {postIconStatus(e.row.icon_post)} </>) }
            renderCell: (e) => { return <PostIconStatus code={e.row.icon_post} /> }
        },
        {
            field: 'icon_shipment',
            headerName: '',
            width: 1,
            renderCell: (e) => { return (<> {shipmentIconStatus(e.row.icon_shipment)} </>) }
        },
        { field: 'date', headerName: 'Дата', width: 140 },
        { field: 'orderID', headerName: 'Номер заказа', width: 130 },
        { field: 'source_name', headerName: 'Платформа', width: 100 },
        { field: 'address_country', headerName: 'Страна', width: 90 },
        { field: 'address_city', headerName: 'Город', width: 120 },
        { field: 'totalQuantity', headerName: 'Кол-во', width: 70 },
        { field: 'totalOrderPrice', headerName: 'Cтоимость', width: 90 },
        { field: 'user', headerName: 'Клиент', width: 180 },
        { field: 'email', headerName: 'E-mail', width: 190 }
    ]




    useEffect(() => {
        creadOrederList(orders)
    }, [orders])


    useEffect(() => {
        updateUrlPage(paginationModel.page !== 0 ? paginationModel.page : 0)
        // console.log('paginationModel', paginationModel.page)
    }, [paginationModel])


    useEffect(() => {
        if (location && location.state && location.state.from === 'OrderDetail' && location.state?.page) {
            updateUrlPage(location.state.page)
            apiRef.current.setPage(location.state.page);
            location.state = { 'page': 0, 'from': 'OrdersSearchBar' }
        }

    }, [location])


    return (
        <div>
            {/* <Button onClick={() => { apiRef.current.setPage(2) }}>set</Button> */}

            <DataGrid
                id={'init'}
                name={'init'}
                rows={orderList}
                columns={columns}
                density='compact'
                filterMode='client'
                hideFooterSelectedRowCount={false}
                onRowDoubleClick={(e) => { navigateToOrder(e.row) }}
                sortingMode={'client'}
                paginationMode={'client'}
                getRowClassName={(e) => { return e.row.isCancel ? cl.isCancel : ''; }}
                // getAllRowIds={(e)=>{console.log(e)}}
                // onRowClick={(e)=>{test(e)}}
                sx={{ fontSize: '12px' }}

                apiRef={apiRef}
                disableRowSelectionOnClick
                pageSizeOptions={[50]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}

            />
        </div>
    );
}

export default OrdersList;
